// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__h4RKH","boxModel":"styles_boxModel__yZ2Q+","cross":"styles_cross__+2pSO"};